var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 78,
    viewBox: "0 0 35 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8782 74.1783L23.9388 40.0517M23.9388 40.0517L32.4236 74.8395M2.50049 29.6278L10.6209 28.1251L21.9841 19.4004L23.9388 26.4004V40.0517M21.9841 19.4004L16.002 31.7278L7.16344 35.3752",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2239 7.59111C11.2239 8.94131 11.7603 10.2362 12.715 11.1909C13.6698 12.1457 14.9647 12.682 16.3149 12.682C17.665 12.682 18.9599 12.1457 19.9147 11.1909C20.8694 10.2362 21.4058 8.94131 21.4058 7.59111C21.4058 6.24092 20.8694 4.94603 19.9147 3.9913C18.9599 3.03657 17.665 2.50021 16.3149 2.50021C14.9647 2.50021 13.6698 3.03657 12.715 3.9913C11.7603 4.94603 11.2239 6.24092 11.2239 7.59111Z",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.3b8685cd8dcd3503eecf41fd725f2f2c.svg";
export { ForwardRef as ReactComponent };